export default __webpack_public_path__ + "static/media/one.0db52501.jpg";